import { remove } from 'lodash';
export default class Files {
    constructor() {
        this._files = [];
    }
    static create(file, propKey, path) {
        const propPath = `${path ? path + '.' : ''}${propKey}`;
        const fileName = `${propPath}___${file.name}`;
        const renamedFile = new File([file], fileName);
        return renamedFile;
    }
    add(file) {
        remove(this._files, { name: file.name });
        this._files.push(file);
    }
    get() {
        return this._files;
    }
    reset() {
        this._files = [];
    }
}
